import { Component, OnInit } from '@angular/core';
import { MessageService, Message } from 'primeng/api';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ReportService } from 'src/app/services/report.service';

@Component({
  templateUrl: './expiration-list.component.html'
})
export class ExpirationListComponent implements OnInit {
  mySortBy: string;  // Sort By Type
    sortByList = [];

    displayState: any = {
        workingDiv: false,
        summaryDiv: false,
    };

    constructor(private utilService: UtilitiesService, private messageService: MessageService,
                private  reportService: ReportService) { }

    ngOnInit() {
        // this.sortByListOLD = ['Case Number', 'Applicant', 'Status', 'SubStatus', 'Date Received', 'Expiration Date'];
        this.mySortBy = '';
        this.sortByList = [
          { val: 'CaseNum', desc: 'Case Number'},
          { val: 'ApplicantName', desc: 'Applicant' },
          { val: 'Status', desc: 'Status'},
          { val: 'SubStatus', desc: 'Substatus'},
          { val: 'DateReceived', desc: 'Date Received'},
          { val: 'DateExp', desc: 'Expiration Date'}
        ];
    }

    runExpirationListReport() {
        this.utilService.doAudit(this.mySortBy, 'mySort:');
        const sortBy = this.mySortBy;
        if (sortBy.length < 1) {
            this.showToast({key: 'toast', severity: 'info', detail: 'Please select a Sort By Type', summary: 'Info' });
            return;
        }
        this.utilService.doAudit('calling expiration list function...');
        this.displayState.workingDiv = true;
        this.reportService.getExpirationList(sortBy).subscribe(data => {
          this.utilService.doAudit('got response from expiration list:');
          this.displayState.workingDiv = false;
          if (data) {
            // const myBlob = new Blob(myData, {type: 'application/pdf'} );
            const myUrl = URL.createObjectURL(data);
            window.open(myUrl, '_blank');
            URL.revokeObjectURL(myUrl);
          }
        })
    }

    // Toaster-related methods
    showToast(msg: Message) {
        this.messageService.add(msg);
        }

    clear() {
        this.messageService.clear();
    }


}
